var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "akl" }, [
      _c("div", { staticClass: "bod-view-txt" }, [
        _c("div", { staticClass: "os_noticeRes" }, [
          _c(
            "div",
            {
              staticClass: "osResHeader",
              staticStyle: { "background-color": "#cadad3" }
            },
            [
              _c("div", { staticClass: "widL padTL txtC" }, [
                _c(
                  "p",
                  {
                    staticClass: "fntH1 bold",
                    staticStyle: { color: "#231f5c", "line-height": "1.18" }
                  },
                  [
                    _vm._v("\n                너랑 나랑 나트랑"),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", { staticClass: "disIb" }, [
                      _vm._v("2020 회계연도")
                    ]),
                    _c("br", { staticClass: "pcOnly" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "disIb" }, [
                      _vm._v("여행 프로모션 시행")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "posRe fntH5",
                    staticStyle: { top: "1.5em", color: "#212121" }
                  },
                  [
                    _vm._v(
                      "\n                2020 회계연도 리더십 세미나의 또 다른 이름,"
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "b",
                      {
                        staticClass: "disIb padTS padBS fntH4 bolder",
                        staticStyle: { color: "#000" }
                      },
                      [_vm._v("“너랑 나랑 나트랑”")]
                    ),
                    _c("br"),
                    _vm._v("\n                한 해의 성공을 함께 나누는 곳, "),
                    _c("span", { staticClass: "disIb" }, [
                      _vm._v("나트랑에 더 많은 사업자분들을 모시기 위해 ")
                    ]),
                    _vm._v(" "),
                    _c("br", { staticClass: "pcOnly" }),
                    _vm._v(
                      "\n                Amway Korea에서는 다양한 프로모션을 준비했습니다. "
                    ),
                    _c("span", { staticClass: "disIb" }, [
                      _vm._v("아래 내용을 참고 부탁드립니다.")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("img", {
                  attrs: {
                    src:
                      "https://www.amway.co.kr/_ui/_noticeImg/2019/09/0920_nca/vis.png",
                    alt: ""
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { color: "#56565a" } }, [
            _c(
              "div",
              {
                staticClass: "cont1",
                staticStyle: { "background-color": "#fff" }
              },
              [
                _c("div", { staticClass: "widL padTL txtC" }, [
                  _c("div", { staticClass: "marBML padTS" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "https://www.amway.co.kr/_ui/_noticeImg/2019/09/0920_nca/icon01.png",
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "marTS fntH3 bold",
                        staticStyle: { color: "#0070b0" }
                      },
                      [_vm._v("프로모션 1")]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "padTS  fntH4 light" }, [
                      _vm._v("9월 여행점수 20% UP")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "padBL fntH6 fntL txtC" }, [
                    _c("div", { staticClass: "clearfix" }, [
                      _c(
                        "p",
                        {
                          staticClass: "marBM bold",
                          staticStyle: {
                            float: "left",
                            background: "#3bb2d0",
                            width: "20%",
                            padding: "3px 0",
                            color: "#fff",
                            "border-radius": "2em",
                            "line-height": "1.5"
                          }
                        },
                        [_vm._v("기간")]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "marBM fntH5 light txtL",
                          staticStyle: {
                            float: "right",
                            width: "80%",
                            "padding-top": "3px",
                            "padding-left": "1em"
                          }
                        },
                        [_vm._v("2019년 9월")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }, [
                      _c(
                        "p",
                        {
                          staticClass: "marBM bold",
                          staticStyle: {
                            float: "left",
                            background: "#3bb2d0",
                            width: "20%",
                            padding: "3px 0",
                            color: "#fff",
                            "border-radius": "2em",
                            "line-height": "1.5"
                          }
                        },
                        [_vm._v("대상")]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "marBM fntH5 light txtL",
                          staticStyle: {
                            float: "right",
                            width: "80%",
                            "padding-top": "3px",
                            "padding-left": "1em"
                          }
                        },
                        [_vm._v("해당기간 SP 유자격 월을 달성한 모든 ABO")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }, [
                      _c(
                        "p",
                        {
                          staticClass: "bold",
                          staticStyle: {
                            float: "left",
                            background: "#3bb2d0",
                            width: "20%",
                            padding: "3px 0",
                            color: "#fff",
                            "border-radius": "2em",
                            "line-height": "1.5"
                          }
                        },
                        [_vm._v("혜택")]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "fntH5 light txtL",
                          staticStyle: {
                            float: "right",
                            width: "80%",
                            "padding-top": "3px",
                            "padding-left": "1em"
                          }
                        },
                        [_vm._v("9월 해당 월 달성 여행점수의 20% 추가")]
                      )
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "cont2",
                staticStyle: { "background-color": "#f4f4f4" }
              },
              [
                _c("div", { staticClass: "widL padTL txtC" }, [
                  _c("div", { staticClass: "marBML padTS" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "https://www.amway.co.kr/_ui/_noticeImg/2019/09/0920_nca/icon02.png",
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "marTS fntH3 bold",
                        staticStyle: { color: "#231f5c" }
                      },
                      [_vm._v("프로모션 2")]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "padTS  fntH4 light" }, [
                      _vm._v("4차수 이상 도전자 조건완화")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "padBL fntH6 fntL txtC" }, [
                    _c("div", { staticClass: "clearfix" }, [
                      _c(
                        "p",
                        {
                          staticClass: "marBM bold",
                          staticStyle: {
                            float: "left",
                            background: "#62727f",
                            width: "20%",
                            padding: "3px 0",
                            color: "#fff",
                            "border-radius": "2em",
                            "line-height": "1.5"
                          }
                        },
                        [_vm._v("기간")]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "marBM fntH5 light txtL",
                          staticStyle: {
                            float: "right",
                            width: "80%",
                            "padding-top": "3px",
                            "padding-left": "1em"
                          }
                        },
                        [_vm._v("2019년 09월 ~ 2020년 08월")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }, [
                      _c(
                        "p",
                        {
                          staticClass: "marBM bold",
                          staticStyle: {
                            float: "left",
                            background: "#62727f",
                            width: "20%",
                            padding: "3px 0",
                            color: "#fff",
                            "border-radius": "2em",
                            "line-height": "1.5"
                          }
                        },
                        [_vm._v("대상")]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "marBM fntH5 light txtL",
                          staticStyle: {
                            float: "right",
                            width: "80%",
                            "padding-top": "3px",
                            "padding-left": "1em"
                          }
                        },
                        [
                          _vm._v(
                            "여행차수 4차 이상에 도전하시는 2020 회계연도 마감 유자격 플래티늄 이상 ABO"
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }, [
                      _c(
                        "p",
                        {
                          staticClass: "bold",
                          staticStyle: {
                            float: "left",
                            background: "#62727f",
                            width: "20%",
                            padding: "3px 0",
                            color: "#fff",
                            "border-radius": "2em",
                            "line-height": "1.5"
                          }
                        },
                        [_vm._v("조건")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "marBM fntH5 light txtL",
                          staticStyle: {
                            float: "right",
                            width: "80%",
                            "padding-top": "3px",
                            "padding-left": "1em"
                          }
                        },
                        [
                          _vm._v(
                            "아래 조건 1) & 2) 모두 달성 시 나트랑 리더십 세미나 초청\n                            "
                          ),
                          _c("div", { staticClass: "marTS fntH6 fntL light" }, [
                            _c("ol", [
                              _c("li", [
                                _vm._v(
                                  "1) 2019 회계연도 대비 여행점수 240만점 이상 성장"
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "2) 2020 회계연도 마감 여행점수 1,040만점 이상 달성"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "marTM" }, [
                              _vm._v("※ 4차수에 도전하는 경우 달성 사례 예시")
                            ]),
                            _vm._v(" "),
                            _c("ul", [
                              _c("li", { staticClass: "marTS" }, [
                                _vm._v(
                                  "- 4차수 목표 점수(1,520만점)로 달성 :\n                                        "
                                ),
                                _c("p", { staticClass: "fntH6 light" }, [
                                  _vm._v(
                                    "2019 회계연도 1,400만점으로 마감한 후 올해 여행점수 달성을 위해 120만점을 성장하여 1,520만점 목표 점수 달성 시 리더십 세미나 참석이 가능합니다."
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", { staticClass: "marTS" }, [
                                _vm._v(
                                  "- 프로모션 조건(1,040만점 및 240만점 성장)으로 달성 :\n                                        "
                                ),
                                _c("p", { staticClass: "fntH6 light" }, [
                                  _vm._v(
                                    "2019 회계연도 1,200만점으로 마감하고 올해 1,440만점을 달성한 4회차 도전자의 경우 올해 총 여행점수가 1,040만점 이상이며, 전년 대비 240만점을 성장 시켰으므로 프로모션 조건을 통해 리더십 세미나 참석이 가능합니다."
                                  )
                                ])
                              ])
                            ])
                          ])
                        ]
                      )
                    ])
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "cont3 marTL",
              staticStyle: { "background-color": "#cadad3" }
            },
            [
              _c("div", { staticClass: "widL padTXL padBXL txtC" }, [
                _c(
                  "p",
                  {
                    staticClass: "fntH2 fntL bold",
                    staticStyle: {
                      color: "#231f5c",
                      "line-height": "1.18",
                      "letter-spacing": "-3.5px"
                    }
                  },
                  [
                    _vm._v("\n                2020 회계연도 리더십 세미나 "),
                    _c("br"),
                    _vm._v(
                      "\n                추가 프로모션 시행 안내\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "marTL fntH6 fntL",
                    staticStyle: { color: "#212121" }
                  },
                  [
                    _vm._v(
                      "\n                전세계적인 코로나19의 대유행으로 교육 및 미팅조차 쉽지 않은 시기입니다. 그러나 대면 활동이 여러 방면으로 차단된 이 어려운 시기에도 Amway 비즈니스를 지속적으로 이끌어 나가는 여러분들의 노력과 헌신이 그 어느 때보다 귀하고 값지다고 생각되며, 이에 Amway Korea는 우선 "
                    ),
                    _c("span", { staticClass: "disIb" }, [
                      _vm._v("감사의 말씀을 드리고 싶습니다.")
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n\n                코로나19 장기화로 인한 스트레스로 자칫 무기력해질 수 있는 상황이지만 그러한 어려움 속에서도 비즈니스 성장에 대한 노력을 보여주시는 리더 분들께 힘을 실어드리고, "
                    ),
                    _c("span", { staticClass: "disIb" }, [
                      _vm._v("리더십 세미나 자격 달성에")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "disIb" }, [
                      _vm._v(
                        "한걸음 더 다가가는데 도움이 되고자 추가 여행 프로모션을 준비했습니다. "
                      )
                    ]),
                    _c("br"),
                    _vm._v("아래 내용을 참고 부탁드립니다.\n            ")
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { color: "#56565a" } }, [
            _c("div", { staticStyle: { "background-color": "#fff" } }, [
              _c("div", { staticClass: "widL padTL txtC" }, [
                _c("div", { staticClass: "marBML padTS" }, [
                  _c("img", {
                    staticClass: "icoS",
                    attrs: {
                      src:
                        "https://www.amway.co.kr/_ui/_noticeImg/2019/09/0920_nca/icon01.png",
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "marTS fntH3 bold",
                      staticStyle: { color: "#0070b0" }
                    },
                    [_vm._v("345월 여행점수 10% UP")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "padBL fntH6 fntL txtC" }, [
                  _c("div", { staticClass: "clearfix" }, [
                    _c(
                      "p",
                      {
                        staticClass: "marBM bold",
                        staticStyle: {
                          float: "left",
                          background: "#3bb2d0",
                          width: "20%",
                          padding: "3px 0",
                          color: "#fff",
                          "border-radius": "2em",
                          "line-height": "1.5"
                        }
                      },
                      [_vm._v("기간")]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "marBM fntH5 light txtL",
                        staticStyle: {
                          float: "right",
                          width: "80%",
                          "padding-top": "3px",
                          "padding-left": "1em"
                        }
                      },
                      [_vm._v("2020년 3월 ~ 5월(3개월간)")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }, [
                    _c(
                      "p",
                      {
                        staticClass: "marBM bold",
                        staticStyle: {
                          float: "left",
                          background: "#3bb2d0",
                          width: "20%",
                          padding: "3px 0",
                          color: "#fff",
                          "border-radius": "2em",
                          "line-height": "1.5"
                        }
                      },
                      [_vm._v("대상")]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "marBM fntH5 light txtL",
                        staticStyle: {
                          float: "right",
                          width: "80%",
                          "padding-top": "3px",
                          "padding-left": "1em"
                        }
                      },
                      [
                        _vm._v("해당 기간 SP 유자격 월을 달성한 "),
                        _c("span", { staticClass: "disIb" }, [
                          _vm._v("모든 ABO")
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }, [
                    _c(
                      "p",
                      {
                        staticClass: "bold",
                        staticStyle: {
                          float: "left",
                          background: "#3bb2d0",
                          width: "20%",
                          padding: "3px 0",
                          color: "#fff",
                          "border-radius": "2em",
                          "line-height": "1.5"
                        }
                      },
                      [_vm._v("혜택")]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "fntH5 light txtL",
                        staticStyle: {
                          float: "right",
                          width: "80%",
                          "padding-top": "3px",
                          "padding-left": "1em"
                        }
                      },
                      [_vm._v("해당 월 달성 여행 점수의 10% 추가")]
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { "background-color": "#f4f4f4" } }, [
              _c("div", { staticClass: "widL padTL txtC" }, [
                _c("div", { staticClass: "marBML padTS" }, [
                  _c("img", {
                    staticClass: "icoS",
                    attrs: {
                      src:
                        "https://www.amway.co.kr/_ui/_noticeImg/2019/09/0920_nca/icon02.png",
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "marTS fntH3 bold",
                      staticStyle: { color: "#231f5c" }
                    },
                    [_vm._v("나트랑 with Family")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "padBL fntH6 fntL txtC" }, [
                  _c("div", { staticClass: "clearfix" }, [
                    _c(
                      "p",
                      {
                        staticClass: "marBM bold",
                        staticStyle: {
                          float: "left",
                          background: "#62727f",
                          width: "20%",
                          padding: "3px 0",
                          color: "#fff",
                          "border-radius": "2em",
                          "line-height": "1.5"
                        }
                      },
                      [_vm._v("기간")]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "marBM fntH5 light txtL",
                        staticStyle: {
                          float: "right",
                          width: "80%",
                          "padding-top": "3px",
                          "padding-left": "1em"
                        }
                      },
                      [_vm._v("2019년 9월 ~ 2020년 8월")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }, [
                    _c(
                      "p",
                      {
                        staticClass: "marBM bold",
                        staticStyle: {
                          float: "left",
                          background: "#62727f",
                          width: "20%",
                          padding: "3px 0",
                          color: "#fff",
                          "border-radius": "2em",
                          "line-height": "1.5"
                        }
                      },
                      [_vm._v("대상")]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "marBM fntH5 light txtL",
                        staticStyle: {
                          float: "right",
                          width: "80%",
                          "padding-top": "3px",
                          "padding-left": "1em"
                        }
                      },
                      [
                        _vm._v("여행점수를 최종적으로 달성한 "),
                        _c("span", { staticClass: "disIb" }, [
                          _vm._v("모든 ABO")
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }, [
                    _c(
                      "p",
                      {
                        staticClass: "bold",
                        staticStyle: {
                          float: "left",
                          background: "#62727f",
                          width: "20%",
                          padding: "3px 0",
                          color: "#fff",
                          "border-radius": "2em",
                          "line-height": "1.5"
                        }
                      },
                      [_vm._v("혜택")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "marBM fntH5 light txtL",
                        staticStyle: {
                          float: "right",
                          width: "80%",
                          "padding-top": "3px",
                          "padding-left": "1em"
                        }
                      },
                      [
                        _vm._v(
                          "\n                      여행 참석 대상을 자녀에서 가족으로 확대"
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("p", { staticClass: "marTS fntH6 light" }, [
                          _vm._v(
                            "※ 가족 범위는 형제/부모/자녀 및 자녀의 배우자/손자녀이며, 동반 가족 최대 인원은 2명입니다. "
                          ),
                          _c("br"),
                          _vm._v(
                            "(단, 동반가족이 전원 자녀만으로 구성될 경우 인원 제한 없음.)"
                          )
                        ])
                      ]
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "padTL padBL" }, [
              _c("p", { staticClass: "widL fntH6 fntL light txtC" }, [
                _vm._v("건강에 늘 유의하시길 바라며, 많은 리더님들과 "),
                _c("span", { staticClass: "disIb" }, [
                  _vm._v("함께할 수 있기를 바라겠습니다.")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a3dee50", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a3dee50","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/leader-seminar/notice.vue
// module id = null
// module chunks = 